<template>
  <svg
xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
    viewBox="0 0 32 40" style="enable-background:new 0 0 32 32;" xml:space="preserve">
    <path
:fill="crossColor"
      d="M27.71,23.29c-0.39-0.39-1.02-0.39-1.41,0L25,24.59l-1.29-1.29c-0.39-0.39-1.02-0.39-1.41,0s-0.39,1.02,0,1.41L23.59,26  l-1.29,1.29c-0.39,0.39-0.39,1.02,0,1.41C22.49,28.9,22.74,29,23,29s0.51-0.1,0.71-0.29L25,27.41l1.29,1.29  C26.49,28.9,26.74,29,27,29s0.51-0.1,0.71-0.29c0.39-0.39,0.39-1.02,0-1.41L26.41,26l1.29-1.29C28.1,24.32,28.1,23.68,27.71,23.29z" />
    <path
:fill="mapColor"
      d="M5.57,29c0.46,0,0.92-0.13,1.32-0.37l3.7-2.22c0.83-0.5,1.92-0.54,2.79-0.11l4.22,2.11c0.39,0.2,0.77,0.34,1.17,0.44  c0.54,0.13,1.08-0.2,1.21-0.73c0.13-0.54-0.2-1.08-0.73-1.21c-0.25-0.06-0.49-0.15-0.75-0.28l-4.22-2.11  c-0.4-0.2-0.83-0.34-1.27-0.42V5.19c0.17,0.05,0.35,0.11,0.51,0.19l4.22,2.11c0.4,0.2,0.83,0.34,1.27,0.42V21c0,0.55,0.45,1,1,1  s1-0.45,1-1V7.86c0.51-0.11,1-0.29,1.44-0.56l3.7-2.22C26.5,4.87,27,5.15,27,5.57V20c0,0.55,0.45,1,1,1s1-0.45,1-1V5.57  C29,4.15,27.85,3,26.43,3c-0.47,0-0.92,0.13-1.32,0.37l-3.7,2.22c-0.83,0.5-1.92,0.54-2.79,0.11L14.4,3.58  c-0.73-0.37-1.54-0.56-2.36-0.58C12.03,3.01,12.02,3,12,3c-0.02,0-0.04,0.01-0.06,0.01c-0.75,0-1.5,0.14-2.19,0.44L4.82,5.56  C3.71,6.03,3,7.12,3,8.32v18.12C3,27.85,4.15,29,5.57,29z M5,8.32c0-0.4,0.24-0.76,0.61-0.92l4.93-2.11  c0.15-0.06,0.31-0.1,0.46-0.14v18.99c-0.51,0.11-0.99,0.29-1.44,0.56l-3.7,2.22C5.5,27.13,5,26.85,5,26.43V8.32z" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  mapColor?: 'orange' | 'black';
  crossColor?: 'orange' | 'black';
}>(), {
  mapColor: 'orange',
  crossColor: 'black',
});


const mapColor = computed(() => props.mapColor === 'orange' ? '#FF7B00' : '#000000');

const crossColor = computed(() => props.crossColor === 'orange' ? '#FF7B00' : '#000000');
</script>